import React from 'react';

/** 準備中の機能名と再開案内を表示する。 */
const VisitorPreparingNotice = ({ label }: { label: string }): React.JSX.Element => (
  <section role="status" className="my-4 border-4 border-app-quest-night bg-app-panel px-5 py-8 text-center shadow-[4px_4px_0_rgba(22,36,58,0.24)]">
    <p className="text-sm font-bold text-app-text-secondary">{label}</p>
    <p className="mt-3 text-xl font-extrabold text-app-quest-night">今は準備中です</p>
    <p className="mt-3 text-sm leading-6 text-app-text">準備ができるまで、もうしばらくお待ちください。</p>
  </section>
);

export default VisitorPreparingNotice;
